import { GetPlanAdapter } from '../../../adapter';

export default async function GetPlanUseCase(event) {
    const url = window.location.href;
    const isLocalhost = url.includes('localhost') || url.includes('hcr.dev.bpimsapps.com');
    const isUAT = url.includes('hcr.uat.bpimsapps.com');
    const isProd = url.includes('homeprotectionrenewal.bpims.com');
    const [, stage, , flag] = url.split('.');

    // prepare data
    const endpoint = isLocalhost
        ? 'https://partners-api.dev.bpimsapps.com/plans/v2'
        : isUAT
        ? 'https://partners-api.uat.bpimsapps.com/plans/v2'
        : isProd
        ? `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/plan/v2`
        : `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/plan/v2`;

    // const requestUrl = 'https://partners-api.dev.bpimsapps.com/plans';

    const payload = { params: "HCR" };

    // handle request
    const result = await GetPlanAdapter(endpoint, JSON.stringify(payload));
    
    return result.data.data;
}
